export class FilterLabel {

	static selector = '.js-filter-types';

	parent;
	content;
	parameters;
	html;

	constructor(parent, content, parameters) {
		this.parent = parent;
		this.content = content;
		this.parameters = parameters ? parameters : {};
	}

	getHtml() {
		let self = this;

		self.buildHtml();
		if (! self.html) {
			self.buildHtml();
		}

		return self.html;
	}

	getContent() {
		let self = this;

		return self.content;
	}

	buildHtml() {
		let self = this;

		let label = document.createElement('div');
		label.classList.add('c-tk-filter__label');

		let dismiss = document.createElement('span');
		dismiss.classList.add('c-tk-filter__label-dismiss');
		dismiss.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20"><path d="M3.85 2.32a1.09 1.09 0 1 0-1.53 1.53L8.46 10l-6.14 6.15a1.09 1.09 0 1 0 1.53 1.53L10 11.54l6.15 6.14a1.09 1.09 0 1 0 1.53-1.53L11.54 10l6.14-6.15a1.09 1.09 0 1 0-1.53-1.53L10 8.46 3.85 2.32Z"/></svg>';
		dismiss.addEventListener('click', function() {
			self.dismiss();
		});

		label.innerHTML = self.content;
		label.appendChild(dismiss);

		self.html = label;
	}

	dismiss() {
		let self = this;

		self.parent['labelDismissed'](self);
	}
}
